import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const StateCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> = {
  header: "State",
  cell: (row) => {
    return row.destinationAddress.province ?? "";
  },
};
